function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_9_514)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.753 9.47656L5.885 5.62656C6.13879 5.43646 6.44525 5.32967 6.76222 5.3209C7.07919 5.31212 7.39109 5.40179 7.655 5.57756V5.57756C7.8283 5.69331 7.97619 5.84314 8.08967 6.01794C8.20314 6.19273 8.27981 6.38881 8.31499 6.59421C8.35018 6.79961 8.34314 7.01003 8.29432 7.21263C8.24549 7.41522 8.15589 7.60574 8.031 7.77256L6.753 9.47256L16.5 9.47256C16.8978 9.47256 17.2794 9.6306 17.5607 9.9119C17.842 10.1932 18 10.5747 18 10.9726C18 11.3704 17.842 11.7519 17.5607 12.0332C17.2794 12.3145 16.8978 12.4726 16.5 12.4726L10.5 12.4726L9.572 16.6466C9.41381 17.3585 9.00171 17.9884 8.41275 18.4186C7.82379 18.8487 7.09831 19.0495 6.372 18.9836L0.749999 18.4726L0.753 9.47656Z",
  stroke: "#F6921E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.002 10.9766L23.252 10.9766",
  stroke: "#F6921E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2539 13.9766L21.7539 15.4766",
  stroke: "#F6921E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.252 7.97656L21.752 6.47656",
  stroke: "#F6921E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.002 14.7266L18.002 16.9766",
  stroke: "#F6921E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.002 7.22656L18.002 4.97656",
  stroke: "#F6921E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9_514"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(24) rotate(90)"
})));

function SvgFingerPointing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerPointing);
export default __webpack_public_path__ + "static/media/finger-pointing.d60f4cb5.svg";
export { ForwardRef as ReactComponent };